//
// Quotation
//
// Import this file using the following HTML or equivalent:
// <script src="dist/js/quotation.min.js" type="text/javascript"></script>
//

jQuery( document ).ready( function( $ ) {

    let Cookies = require('./../../../build/node_modules/@components/js-cookie/src/js.cookie');

	var $body = $( 'body' );

	function update_quotation() {

		var quotation = (typeof Cookies.get( 'quotation' ) != 'undefined' ) ? JSON.parse( Cookies.get( 'quotation' ) ) : [];
		var $quotationCount = $( '#quotation-count' );
		var $quotationDropdown = $( '#quotation-dropdown' );

		if ( quotation.length === 0 ) {

			$quotationCount.hide();

		} else {

			$quotationCount.show();

		}

		$quotationCount.text( quotation.length );

		$.ajax( {
			url: window.quotation_data.ajax_url,
			type: 'post',
			data: {
				action: 'quotation_dropdown'
			},
			success: function( data ) {

				$( '.top-menu__quotation', $quotationDropdown ).remove();
				$quotationDropdown.append( data );

			}
		} );

	}

	update_quotation();

	$body.on( 'click', '#quotation-dropdown > a', function( event ) {

		var quotation = (typeof Cookies.get( 'quotation' ) != 'undefined' ) ? JSON.parse( Cookies.get( 'quotation' ) ) : [];

		if ( quotation.length > 0 ) {

			event.preventDefault();

			var $li = $( this ).parents( 'li' );
			var $quotationDropdown = $( '.top-menu__quotation', $li );

			$quotationDropdown.toggle();

		}

	} );

	$body.on( 'click', 'a[href="#add-to-quotation"]', function( event ) {

		event.preventDefault();

		$( '.top-menu' ).removeClass( 'top-menu--hidden' );
		$( '.header' ).removeClass( 'header--sticky' );

		var $this = $( this );
		var ids = $this.data( 'ids' );
		var quotation = (typeof Cookies.get( 'quotation' ) != 'undefined' ) ? JSON.parse( Cookies.get( 'quotation' ) ) : [];
		var cart = $( '#quotation-dropdown' );
		var imgtodrag = $( '.details .details__col' ).find( 'img' ).eq( 0 );

		if ( imgtodrag.length === 0 ) {
			// We're on a post type archive
			imgtodrag = $this.parent().find( 'img' );
		}

		var $amount = $this.siblings('.amount');
		var amount = 1;

		if ( $amount.length > 0 ) {
			amount = parseInt( $amount.find('input').val() );
		}

		var inQuote = false;

		// Check if item already in quotation folder and adjust the amount if needed
		for ( var i = 0; i < quotation.length; i++ ) {
			if ( quotation[i][ids[0].language] === ids[0].id ) {
				inQuote             = true;
				quotation[i].amount = amount;
				break;
			}
		}

		// If item not already in quotation folder, add it
		if ( inQuote === false ) {
			var item = {
				'amount': amount
			};

			// Add associated languages and ids e.g. "nl": 1234
			for ( var c = 0; c < ids.length; c++ ) {
				item[ids[c].language] = ids[c].id;
			}

			quotation.push( item );
		}

		Cookies.set( 'quotation', JSON.stringify( quotation ), { expires: 7 } );

		if ( imgtodrag.length > 0 ) {

			var imgclone = imgtodrag.clone()
				.offset( {
					top: imgtodrag.offset().top,
					left: imgtodrag.offset().left
				} )
				.css( {
					'opacity': '0.5',
					'position': 'absolute',
					'height': '150px',
					'width': '150px',
					'z-index': '5000'
				} )
				.appendTo( $( 'body' ) )
				.animate( {
					'top': cart.offset().top + 10,
					'left': cart.offset().left + 10,
					'width': 75,
					'height': 75
				}, 1000 );

			imgclone.animate( {
				'width': 0,
				'height': 0
			}, function() {

				$( this ).detach();
				update_quotation();

			} );

		} else {

			update_quotation();

		}

	} );

	$body.on( 'click', 'a[href="#delete-from-quotation"]', function( event ) {

		event.preventDefault();

		var $this = $( this );
		var quotation = (typeof Cookies.get( 'quotation' ) != 'undefined' ) ? JSON.parse( Cookies.get( 'quotation' ) ) : [];
		var itemId = $this.data( 'id' );
		var itemLanguage = $this.data( 'language' );

		// Return items where the ID doesn't match the one we want to remove
		quotation = jQuery.grep( quotation, function( item ) {
			return item[itemLanguage] != itemId;
		} );

		Cookies.set( 'quotation', JSON.stringify( quotation ), { expires: 7 } );

		update_quotation();

	} );

} );